// AI Generated Test
import { AfterViewInit, Component, Input, OnInit, ViewChild } from '@angular/core';
import { TranslateService } from '@client/app/services/translate/translate.service';
import { PolicyFormHelperService } from '@client/app/blocks/helpers/policy-form-helper/policy-form.helper.service';
import { MonDialog } from '@client/app/modules/dialog-upgrade-wrapper/mon-dialog.service';
import { NgForm } from '@angular/forms';
import { FormUtils } from '@client/ng2/shared/form-utils';

import { safeClone } from '@client/app/shared/utils/object-utils';
@Component({
    selector: 'form-global-policy-dialog-rule-readability',
    templateUrl: './form-global-policy-dialog-rule-readability.component.html',
    standalone: false,
})
export class FormGlobalPolicyDialogRuleReadabilityComponent implements OnInit, AfterViewInit {
    @Input() cRule: any;
    @Input() monDialogId: any;

    @ViewChild('policyRuleForm') policyRuleForm?: NgForm;

    typeOptions: any[] = [];
    queryOptions: any[] = [];

    constructor (
        private policyFormHelperService: PolicyFormHelperService,
        private translateService: TranslateService,
        private monDialog: MonDialog,
    ) {}

    ngOnInit (): void {
        this.activate();
    }

    ngAfterViewInit () {
        this.monDialog.setFocus(this.monDialogId, this.policyRuleForm);
    }

    activate (): void {
        this.cRule.inverse = false;
        this.policyFormHelperService.setRuleType(this.cRule.type);
        this.setupTypeOptions();
        this.setupQueryOptions();
    }

    setupTypeOptions (): void {
        this.typeOptions = this.policyFormHelperService.getOptionsByRuleType();
        this.cRule.operator = this.cRule.operator || this.typeOptions[1].type;
    }

    setupQueryOptions (): void {
        this.queryOptions = [
            {
                value: 1,
                translation: this.translateService.getString('Below 5th grade'),
            },
            {
                value: 5,
                translation: this.translateService.getString('5th grade'),
            },
            {
                value: 6,
                translation: this.translateService.getString('6th grade'),
            },
            {
                value: 7,
                translation: this.translateService.getString('7th grade'),
            },
            {
                value: 8,
                translation: this.translateService.getString('8th to 9th grade'),
            },
            {
                value: 10,
                translation: this.translateService.getString('10th to 12th grade'),
            },
            {
                value: 15,
                translation: this.translateService.getString('College'),
            },
            {
                value: 17,
                translation: this.translateService.getString('College graduate'),
            },
        ];

        if (!this.cRule.query) {
            this.cRule.query = this.queryOptions[3].value;
        } else {
            this.cRule.query = parseInt(this.cRule.query);
        }
    }

    close (): void {
        const newRule = safeClone(this.cRule);
        newRule.sub_entry = newRule.sub_entry.join(',');
        FormUtils.markFormAsPristine(this.policyRuleForm);
        this.monDialog.close(this.monDialogId, newRule);
    }
}
